import { useContext, useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { KycManager } from "../../context-api/KycContext";
import { variableManager } from "../../context-api/VariableContex";
import "../../styles/modals.scss";
import "../../styles/kycDocUpload.scss";
import axios from "axios";
import axiosInstance from "../../utils/axios_instance";
import { RenameFile } from "../../utils/RenameFiles";
export default function KycDocumentUploads(props) {
  const {
    toverify,
    // handleVerifyBvn,
    showVeriSuccess,
    setShowVeriSuccess,

    modalShowDocumentUpload,
    setModalShowDocumentUpload,
  } = useContext(KycManager);

  const { user, msg, setMsg, handleGetUser } = useContext(variableManager);
  const [empty, setEmpty] = useState(false);

  const [doc, setDoc] = useState({
    cacCertificate: "",
    meMart: "",
    forms: "",
  });

  const [docToUpload, setDocToUpload] = useState({
    cacCertificate: "",
    meMart: "",
    forms: "",
  });

  const [docPreview, setDocPreview] = useState({
    cacCertificate: "",
    meMart: "",
    forms: "",
  });

  function handleDocChange(e) {
    setMsg({ ...msg, spinner: false });
    const value = RenameFile(e.target.files[0], user.businessName);
    const field = e.target.name;
    setDoc({
      ...doc,
      [field]: value,
    });
    setDocPreview({
      ...docPreview,
      [field]: URL.createObjectURL(value),
    });
  }

  function handleValidation() {
    if (doc.cacCertificate && doc.forms && doc.meMart) {
      handleKycDocumentsUpload();
    } else {
      setEmpty(true);
    }
  }

  async function handleKycDocumentsUpload() {
    setMsg({ ...msg, spinner: true });
    const files = [doc.cacCertificate, doc.forms, doc.meMart];

    // An array to store the promises from the Axios POST requests
    const uploadPromises = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formdata = new FormData();

      formdata.append("file", file);
      formdata.append("upload_preset", "business-documents");

      // Push the promise into the array
      uploadPromises.push(
        axios
          .post(
            `${process.env.REACT_APP_CLOUDINARY_URL}/${process.env.REACT_APP_CLOUDINARY_USERNAME}/image/upload`,
            formdata
          )
          .then((resp) => resp.data.secure_url)
      );
    }

    try {
      // Wait for all upload promises to complete
      const uploadedUrls = await Promise.all(uploadPromises);

      // Update the docToUpload object with the URLs
      setDocToUpload({
        ...docToUpload,
        cacCertificate: uploadedUrls[0],
        forms: uploadedUrls[1],
        meMart: uploadedUrls[2],
      });

      // make the final axios POST request with the updated docToUpload
      const resp = await axiosInstance.post(
        `/business/documents/submit`,
        docToUpload
      );

      setMsg({ ...msg, spinner: false });
      handleGetUser();
      setModalShowDocumentUpload({
        ...modalShowDocumentUpload,
        upload:false,
        success: true,
      });
    } catch (error) {
      console.error("Error:", error);
      setMsg({ ...msg, spinner: false });
    }
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton
        onHide={() => {
          setShowVeriSuccess({ ...showVeriSuccess, error: "" });
          setMsg({ ...msg, spinner: false });
        }}
      ></Modal.Header>
      <Modal.Body className="modalContent width-90 kyc-document-upload-container">
        <h2>Document Upload</h2>
        <p>
          Kindly upload these document types: CAC certificate, MEMART, Forms 2&
          7.
        </p>

        <div className="document-upload-field">
          <label htmlFor="cacCertUpload">
            Upload CAC Certificate <sup className="mo-danger">*</sup>{" "}
          </label>
          <div className="input-section">
            <input
              type="file"
              id="cacCertUpload"
              accept="image/* pdf"
              name="cacCertificate"
              onChange={(e) => {
                handleDocChange(e);
              }}
            />
            {docPreview.cacCertificate ? (
              <a href={docPreview.cacCertificate} target="blank">
                Preview
              </a>
            ) : null}
          </div>

          {empty && !doc.cacCertificate ? (
            <div className="mo-danger">This field is required</div>
          ) : null}
        </div>

        <div className="document-upload-field ">
          <label htmlFor="mermart">
            Upload MERMART <sup className="mo-danger">*</sup>{" "}
          </label>
          <div className="input-section">
            <input
              type="file"
              id="mermart"
              accept="image/* pdf"
              name="meMart"
              onChange={(e) => {
                handleDocChange(e);
              }}
            />
            {docPreview.meMart ? (
              <a href={docPreview.meMart} target="blank">
                Preview
              </a>
            ) : null}
          </div>
          {empty && !doc.meMart ? (
            <div className="mo-danger">This field is required</div>
          ) : null}
        </div>

        <div className="document-upload-field ">
          <label htmlFor="form2and7">
            Upload Forms 2 & 7 <sup className="mo-danger">*</sup>{" "}
          </label>
          <div className="input-section">
            <input
              type="file"
              id="form2and7"
              accept="image/* pdf"
              name="forms"
              onChange={(e) => {
                handleDocChange(e);
              }}
            />
            {docPreview.forms ? (
              <a href={docPreview.forms} target="blank">
                Preview
              </a>
            ) : null}
          </div>
          {empty && !doc.forms ? (
            <div className="mo-danger">This field is required</div>
          ) : null}
        </div>

        <p className="text-danger text-center fw-bold">
          {showVeriSuccess.error ? showVeriSuccess.error : null}
        </p>

        <div className="buttons">
          <button
            className={
              doc.cacCertificate && doc.forms && doc.meMart
                ? "btn-active"
                : "btn-inactive"
            }
            disabled={msg.spinner ? "{true}" : ""}
            onClick={() => {
              handleValidation();
            }}
          >
            {msg.spinner ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
